import { render, staticRenderFns } from "./CategoriaWeb.vue?vue&type=template&id=21ee6b4b&lang=pug"
import script from "./CategoriaWeb.vue?vue&type=script&lang=js"
export * from "./CategoriaWeb.vue?vue&type=script&lang=js"
import style0 from "./CategoriaWeb.vue?vue&type=style&index=0&id=21ee6b4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports